import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static values = { url: String }

  connect() {
    reactor(this)
  }

  morph(event) {
    if (event?.type === "turbo:frame-render") return // this frame's own load, not a page morph

    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    if (frame.hasAttribute("busy")) return
    frame.src = null
    frame.src = this.urlValue
  }
}
